var $147159c978043442$exports = {};
$147159c978043442$exports = {
  "deselectedItem": function deselectedItem(args) {
    return "".concat(args.item, " no seleccionado.");
  },
  "longPressToSelect": "Mantenga pulsado para abrir el modo de selecci\xF3n.",
  "select": "Seleccionar",
  "selectedAll": "Todos los elementos seleccionados.",
  "selectedCount": function selectedCount(args, formatter) {
    return "".concat(formatter.plural(args.count, {
      "=0": "Ning\xFAn elemento seleccionado",
      one: function one() {
        return "".concat(formatter.number(args.count), " elemento seleccionado");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " elementos seleccionados");
      }
    }), ".");
  },
  "selectedItem": function selectedItem(args) {
    return "".concat(args.item, " seleccionado.");
  }
};
export { $147159c978043442$exports as default };